import { useParams } from "react-router";
import { useQuery } from "@tanstack/react-query";
import dayjs from 'dayjs';
import { Title } from '../../utils/title';
import { fetchApi } from "../../services/api";
import { Loader } from "@progress/kendo-react-indicators";
import { ViewModel } from "TypeGen/Order/TransactionLogs/view-model";
import JsonPretty from "components/JsonPretty";
import { PersonHoverCard } from "components/PersonHoverCard";

type RouteComponentParams = { tripId: string; };

const TransactionLogs = () => {
  const { tripId: tripIdParam } = useParams<RouteComponentParams>();

  const { data: logs, isLoading, isError, error } = useQuery({
    queryKey: ['transactionLogs', tripIdParam],
    queryFn: () => fetchApi(`/api/Trip/TransactionLogs/${tripIdParam}`) as Promise<ViewModel>,
    enabled: !!tripIdParam,
  });

  const loadingView = (
    <div className="k-pos-absolute k-top-center mt-5">
      <Loader type="converging-spinner" />
    </div>
  );

  const dataView = () => {
    if (!logs) return null;
    return (
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th>Date Time</th>
            <th>User</th>
            <th>Order Stop</th>
            <th>Trip</th>
            <th>Trip Stop</th>
            <th>Action</th>
            <th>Old</th>
            <th>New</th>
          </tr>
        </thead>
        <tbody>
          {!logs.Logs.length && (
            <tr>
              <td colSpan={8} className="text-center">No Logs.</td>
            </tr>
          )}
          {logs.Logs.map(log => (
            <tr key={log.TransactionLogID}>
              <td>{dayjs.utc(log.ModifiedDateTime).local().format("YYYY-MM-DD HH:mm:ss")}</td>
              <td>
                <PersonHoverCard userId={log.ModifiedByUserID}>
                  <span style={{ borderBottom: "1px dotted" }}>
                    {log.ModifiedByFullName}
                  </span>
                </PersonHoverCard>
              </td>
              <td>{log.OrderStopSequence}</td>
              <td>{log.TripNumber}</td>
              <td>{log.TripStopSequence}</td>
              <td>{log.TypeName}</td>
              <td><JsonPretty json={log.OldData} /></td>
              <td><JsonPretty json={log.NewData} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <>
      <Title string="Logs" />
      <br />
      {isLoading && loadingView}
      {isError && <div className="alert alert-danger">{String(error)}</div>}
      {!isLoading && !isError && dataView()}
    </>
  );
}

export default TransactionLogs;
